import { render, staticRenderFns } from "./HelpBadges.vue?vue&type=template&id=41b752e8"
import script from "./HelpBadges.vue?vue&type=script&lang=js"
export * from "./HelpBadges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports